import { render } from "./AIGC.vue?vue&type=template&id=18523a35&scoped=true&ts=true"
import script from "./AIGC.vue?vue&type=script&lang=ts"
export * from "./AIGC.vue?vue&type=script&lang=ts"

import "./AIGC.vue?vue&type=style&index=0&id=18523a35&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18523a35"]])

export default __exports__